import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  webAppUrl: 'https://dev.miqube.in/web',
  cache: {
    enabled: true,
  },
  api: {
    tenantUrl: 'https://dev.miqube.in/',
    wordpressBaseUrl: 'https://uat.indiqube.com/wp-json/wp/v2',
    razorpayKey: 'rzp_test_kgLQJ838nAK6vk',
  },
};
